var map = {
	"./account.svg": [
		"40dc",
		"icons/icon-account-svg"
	],
	"./charges.svg": [
		"bc4f",
		"icons/icon-charges-svg"
	],
	"./check.svg": [
		"ce6a",
		"icons/icon-check-svg"
	],
	"./circle-dot.svg": [
		"8b6b",
		"icons/icon-circle-dot-svg"
	],
	"./circle.svg": [
		"3594",
		"icons/icon-circle-svg"
	],
	"./client.svg": [
		"abe7",
		"icons/icon-client-svg"
	],
	"./close.svg": [
		"beee",
		"icons/icon-close-svg"
	],
	"./configuration.svg": [
		"4153",
		"icons/icon-configuration-svg"
	],
	"./copy.svg": [
		"f02d",
		"icons/icon-copy-svg"
	],
	"./cred-card.svg": [
		"0df8",
		"icons/icon-cred-card-svg"
	],
	"./customers.svg": [
		"b03e",
		"icons/icon-customers-svg"
	],
	"./dashboard.svg": [
		"d1cc",
		"icons/icon-dashboard-svg"
	],
	"./developer.svg": [
		"bf3a",
		"icons/icon-developer-svg"
	],
	"./direction.svg": [
		"54b8",
		"icons/icon-direction-svg"
	],
	"./download.svg": [
		"6d34",
		"icons/icon-download-svg"
	],
	"./edit.svg": [
		"4907",
		"icons/icon-edit-svg"
	],
	"./ellipsis.svg": [
		"45af",
		"icons/icon-ellipsis-svg"
	],
	"./fees.svg": [
		"4b72",
		"icons/icon-fees-svg"
	],
	"./freearea.svg": [
		"8eda",
		"icons/icon-freearea-svg"
	],
	"./hub.svg": [
		"3423",
		"icons/icon-hub-svg"
	],
	"./info.svg": [
		"5d9a",
		"icons/icon-info-svg"
	],
	"./invites.svg": [
		"4954",
		"icons/icon-invites-svg"
	],
	"./invoices.svg": [
		"ffbd",
		"icons/icon-invoices-svg"
	],
	"./learn-more.svg": [
		"6313",
		"icons/icon-learn-more-svg"
	],
	"./logoJPM.svg": [
		"6030",
		"icons/icon-logoJPM-svg"
	],
	"./logs.svg": [
		"b5bb",
		"icons/icon-logs-svg"
	],
	"./merchant.svg": [
		"9d3b",
		"icons/icon-merchant-svg"
	],
	"./mundi.svg": [
		"1b40",
		"icons/icon-mundi-svg"
	],
	"./no-results.svg": [
		"06ac",
		"icons/icon-no-results-svg"
	],
	"./notification.svg": [
		"0db0",
		"icons/icon-notification-svg"
	],
	"./orders.svg": [
		"99cf",
		"icons/icon-orders-svg"
	],
	"./pagarme.svg": [
		"873f",
		"icons/icon-pagarme-svg"
	],
	"./payment-links.svg": [
		"abd3",
		"icons/icon-payment-links-svg"
	],
	"./payments.svg": [
		"c786",
		"icons/icon-payments-svg"
	],
	"./permission.svg": [
		"34f1",
		"icons/icon-permission-svg"
	],
	"./pix-outline.svg": [
		"791c",
		"icons/icon-pix-outline-svg"
	],
	"./pix.svg": [
		"00fb",
		"icons/icon-pix-svg"
	],
	"./plans.svg": [
		"33df",
		"icons/icon-plans-svg"
	],
	"./pos.svg": [
		"4499",
		"icons/icon-pos-svg"
	],
	"./profile.svg": [
		"23db",
		"icons/icon-profile-svg"
	],
	"./recurrence.svg": [
		"67d0",
		"icons/icon-recurrence-svg"
	],
	"./security.svg": [
		"593a",
		"icons/icon-security-svg"
	],
	"./shop.svg": [
		"00b1",
		"icons/icon-shop-svg"
	],
	"./statistics.svg": [
		"deba",
		"icons/icon-statistics-svg"
	],
	"./subscription.svg": [
		"8e6c",
		"icons/icon-subscription-svg"
	],
	"./subscriptions.svg": [
		"6110",
		"icons/icon-subscriptions-svg"
	],
	"./test.svg": [
		"4cda",
		"icons/icon-test-svg"
	],
	"./trf.svg": [
		"b98c",
		"icons/icon-trf-svg"
	],
	"./users-solid.svg": [
		"808d",
		"icons/icon-users-solid-svg"
	],
	"./users.svg": [
		"790f",
		"icons/icon-users-svg"
	],
	"./webhooks-config.svg": [
		"d879",
		"icons/icon-webhooks-config-svg"
	],
	"./webhooks-skeleton.svg": [
		"f239",
		"icons/icon-webhooks-skeleton-svg"
	],
	"./webhooks.svg": [
		"4759",
		"icons/icon-webhooks-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fc48";
module.exports = webpackAsyncContext;